export enum ManualType {
    Digital = "Digital",
    Pdf = "Pdf"
}